import { h, Component } from 'preact';
import Store from 'store/store';
import * as actions from 'store/actions';
import { joinClasses } from 'utils/utils';
import { getCopy } from 'utils/copy';
import TicketType from 'components/shared/theaters/ticketing/ticketTypes/ticketType.js';
import bb from 'components/shared/theaters/ticketing/bottomBar.sss';
import s from 'components/shared/theaters/ticketing/ticketTypes/ticketTypes.sss';


export default class TicketTypes extends Component {

	goToNext() {
		Store.emit(actions.CREATE_OR_UPDATE_ORDER);
	}

	render(props) {
		const {
			ticketing, // Object - the ticketing state
			currencyCopy
		} = props;

		const { tickets, maxTickets } = ticketing;
		let ticketCount = 0;
		for (const ticketType in tickets) {
			ticketCount += tickets[ticketType].quantity;
		}

		let hasMaxTickets = false;
		if (maxTickets) {
			hasMaxTickets = ticketCount === maxTickets;
		}

		return (
			<div>
				<div class={s.container}>
					<h1 class={s.header}>{getCopy('WHOS_GOING')}</h1>
					{ticketing.ticketTypes && ( // tickets are loaded in
						ticketing.ticketTypes.map(type => (
							<TicketType type={type} ticketing={ticketing} hasMaxTickets={hasMaxTickets} currencyCopy={currencyCopy} />
						))
					)}
				</div>
				<div class={bb.wrapper}>
					<div class={bb.info}>
						<span class={joinClasses(bb.textInfo, bb.ticketNumber)}>
							{ticketCount > 0 ? ticketCount : getCopy('NO')}
						</span>
						<span class={joinClasses(bb.textInfo, bb.ticketCopy)}>{getCopy('TICKETS_SELECTED')}</span>
					</div>
					<div class={bb.buttonWrapper}>
						<button class={bb.button} onClick={this.goToNext} disabled={ticketCount < 1}>{getCopy('NEXT')}</button>
					</div>
				</div>
			</div>
		);
	}

}
